<template>
  <div class="alert-container">
    <b-alert
      v-for="(message, index) in messages"
      :key="index"
      show
      fade
      dismissible
      :variant="message.type"
    >
      <span>{{ message.text }}</span>
    </b-alert>
  </div>
</template>

<script>
import { getSuccessMessage, getErrorMessage, getInfoMessage } from "./MessageBus";
export default {
  name: "Message",
  data() {
    return {
      messages: [
      ],
      timeout: 3500,
    };
  },
  methods: {
    removeAlert() {
      setTimeout(() => {
        this.messages.shift();
      }, this.timeout);
    },
    addInfoMessage(text) {
      console.log(text)
      this.messages.push({
        type: "warning",
        text,
      });
      this.removeAlert();
    },
    addErrorMessage(text) {
      this.messages.push({
        type: "danger",
        text,
      });
      this.removeAlert();
    },
    addSuccessMessage(text) {
      this.messages.push({
        type: "success",
        text,
      });
      this.removeAlert();
    },
  },
  mounted() {
    getErrorMessage((message) => {
      this.addErrorMessage(message);
    });

    getSuccessMessage((message) => {
      this.addSuccessMessage(message);
    });

    getInfoMessage((message) => {
      this.addInfoMessage(message);
    });
  },
};
</script>

<style>
.alert-container {
  position: fixed;
  top: 5px;
  z-index: 10002;
  width: 25%;
  right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Message.vue